import PropTypes from 'prop-types'
import Loader from './Loader'

/**
 * Post-submit loading overlay for embedded D365 forms. Covers the form (whose wrapper
 * must be `position: relative`) while the async post-submit journey runs — file upload,
 * callback POST, redirect — so the member doesn't navigate away before it completes.
 *
 * Mirrors the inline overlay in MemberSelfServiceForms.jsx (Loader + message on an
 * opaque backdrop, announced via role="status"). Pass `className` to tweak the backdrop
 * (e.g. border-radius) to match the host form's shape.
 */
function FormSubmitOverlay({ message = 'Please wait… Do not refresh or navigate away from this page.', className = '' }) {
  return (
    <div
      className={`absolute inset-0 z-10 flex items-center justify-center bg-white overflow-hidden ${className}`}
      role="status"
      aria-live="polite"
    >
      <div className="w-full h-full flex items-center justify-center gap-3 bg-(--nds-secondary-tint-light-blue)/20 overflow-hidden">
        <Loader size="sm" />
        <span className="text-midnight-500 text-lg font-semibold">{message}</span>
      </div>
    </div>
  )
}

FormSubmitOverlay.propTypes = {
  message: PropTypes.string,
  className: PropTypes.string,
}

export default FormSubmitOverlay
